var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',_vm._l((_vm.product.collections),function(collection){return _c('b-badge',{key:collection.id,staticClass:"mx-1",attrs:{"variant":"secondary","itemprop":"isRelatedTo"}},[_vm._v("\n    "+_vm._s(collection.name)+"\n  ")])}))}
var staticRenderFns = []

export { render, staticRenderFns }